var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"video",staticClass:"w-full h-full relative"},[_c('client-only',[(_vm.shouldShowVideo)?_c('vimeo-player',{ref:"vimeoPlayer",staticClass:"object-cover w-full h-full",attrs:{"video-id":_vm.vimeoId,"autoplay":true,"player-width":_vm.width,"player-height":_vm.height,"loop":true,"options":{
                muted: false,
                unmute_button: true,
                progress_bar: true,
                play_button_position: 'center',
                controls: true
            }},on:{"ready":_vm.onVideoReady,"play":_vm.onVideoPlay,"pause":_vm.onVideoPause}}):_c('div',{staticClass:"w-full h-full flex items-center justify-center bg-gray-100"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }